import React from 'react';
import { mapModifiers, ModifierProp } from 'libs/component';
import { Button } from 'components/atoms/button';
import { AnimateSharedLayout, motion } from 'framer-motion';
import { FLOOR_LIST } from 'libs/constants';
import { useTranslation } from 'react-i18next';

export interface FloorSelectorFullItemProps {
  floor: ModifierProp<'LG' | 'LM' | 'G' | 'UM' | '1' | '2'>;
  action?: string;
  active?: boolean;
  onActionClick?: () => void;
}

export const FloorSelectorFullItem: React.FC<FloorSelectorFullItemProps> = ({
  floor,
  action,
  active = false,
  onActionClick,
}) => {
  const { t } = useTranslation();
  const currentFloor = FLOOR_LIST.filter(x => x.level === floor).pop();
  // const imageName = `floor-${floor}.png`;
  // const activeImageName = `floor-${floor}-active.png`;
  const image = currentFloor?.images.inactive;
  const activeImage = currentFloor?.images.active;

  return (
    <div className={mapModifiers('a-floor-selector-full-item', active && 'active')}>
      <figure className="a-floor-selector-full-item__figure">
        <div className="a-floor-selector-full-item__image" onClick={action ? onActionClick : undefined}>
          <motion.div
            initial={{ scale: 1 }}
            animate={{ scale: active ? 1.17176 : 1 }}
            transition={{
              delay: 0.1,
              duration: 0.25,
            }}
            className={mapModifiers(
              'a-floor-selector-full-item__image-holder',
              (floor as string).toLowerCase(),
              action && 'action'
            )}
          >
            <AnimateSharedLayout>
              {image && (
                <motion.img
                  // layoutId="img"
                  initial={{ opacity: 1 }}
                  animate={{ opacity: active ? 0 : 1 }}
                  className="a-floor-selector-full-item__image-inactive"
                  src={image.src}
                  width={image.width}
                  height={image.height}
                  alt={`Level ${floor}`}
                />
              )}
              {activeImage && (
                <motion.img
                  // layoutId="img"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: active ? 1 : 0 }}
                  className="a-floor-selector-full-item__image-active"
                  src={activeImage.src}
                  width={activeImage.width}
                  height={activeImage.height}
                  alt={`Level ${floor}`}
                />
              )}
            </AnimateSharedLayout>
          </motion.div>
        </div>
        <div className="a-floor-selector-full-item__info">
          <figcaption className="a-floor-selector-full-item__label">
            <span className="a-floor-selector-full-item__label-name">{floor}</span>
            <span className="a-floor-selector-full-item__label-level">{t('venue.level')}</span>
          </figcaption>

          {action && (
            <div className="a-floor-selector-full-item__action">
              <Button className="a-floor-selector-full-item__action-button" onClick={onActionClick}>
                {action}
              </Button>
            </div>
          )}
        </div>
      </figure>
    </div>
  );
};
